module.exports = __webpack_public_path__ + "static/media/shubhra_shevkar.a06141f1.png";